<template>
    <div id="teacherTraining" class="margin-top">
        <!--教师课堂-->
        <div class="contentBox" v-show="!loading">
            <div class="layoutBoxWhiteBig">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="item.title" :name="item.id" v-for="item in getTabNameList" :key="item.id">
                        <div class="jy-if">
                            <section class="filterArea">
                                <div class="jyTabFilter"><span class="jyTabFilter-label">分类：</span>
                                    <ul class="jyTabFilter-content" style="margin-left: 59px;">
                                        <li class="jyTabFilter-li" v-for="itemChildren in item.children" :key="itemChildren.id">
                                            <el-button :type="itemChildren.id===selectTagId?'primary':''" @click="getSelectedTag(itemChildren.id)">
                                                {{itemChildren.title}}
                                            </el-button>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                            <section class="courseList" style="min-height:400px;"  v-if="totalRecords>0">
                                <p class="total-2OLNl">共<span class="total-count-3psEA">{{totalRecords}}</span>个主题
                                  </p>
                                <div class="course-cards-1KqlJ" >
                                    <div class="course-card-32E5t source_item course-item-in-list-2nSh9" @click="getInto(item.albumId)" v-for="(item,index) in videoAlbumList" :key="index">
                                        <a class="course-link-22BqB source_item" href="javaScript:;"  >
                                            <div class="course-pic-YTvjF">
                                                <img v-lazy="item.coverImg" :key="item.coverImg" src=""  />
                                            </div>
                                            <div :title="item.name" class="course-title-3Ikmu">
                                                {{item.name}}
                                            </div>
                                            <div class="course-desc-1wQGf"
                                                 :title="item.description">
                                                <p>{{item.description}}</p>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </section>
                            <div v-else style="min-height:400px;">
                               <empty></empty>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="20"
                        layout="prev, pager, next, jumper"
                        :total="totalRecords">
                </el-pagination>
            </div>
        </div>
        <loading :show="loading"></loading>
        <common-target-router :getLocation="getLocation"></common-target-router>

    </div>
</template>
<script>
    import {teacherDyClassroomGrowth, teacherDyClassroomVideoAlbum} from "../../../config";

    export default {
        name: "teacherTraining",
        data() {
            return {
                //加载数据
                loading:false,
                //获取标签的id
                selectTagId:'',
                //获取tabName
                getTabNameList:[],
                activeName: 'first',
                tab1: [
                    {
                        id: 1,
                        name: '全部',
                    },
                    {
                        id: 2,
                        name: '生涯教学能力提升',
                    },
                    {
                        id: 3,
                        name: '新高考落地培训',
                    },
                ],
                //获取target要打开的页面
                getLocation:'',
                //获取当前页
                currentPage:0,
                //总条数
                totalRecords:0,
                //获取专辑列表
                videoAlbumList:[]
            };
        },
        mounted(){
          this.defaultLoadCategory();
        },

        methods: {
            //获取当前选择的分页
            handleCurrentChange(){
                this.lookVideoAlbum();
            },
            getSelectedTag(val){
                this.selectTagId=val;
                this.currentPage=0;
                this.lookVideoAlbum();
            },
            //默认查出分类目录
            async defaultLoadCategory(){
                this.loading=true;
                let result=await teacherDyClassroomGrowth();
                if(result.status){

                    this.getTabNameList=result.data;
                    this.activeName=result.data[0].id;
                    this.secondDefaultSelect(result.data[0].id);
                }else{
                    this.loading=false;
                }
            },
            //切换tab默认选择全部的标签
            secondDefaultSelect(valOutId){
                let zhi=this.getTabNameList.filter((val)=>{
                    return val.id===valOutId;
                });
                this.selectTagId=zhi[0].children[0].id;
                this.currentPage=0;
                this.lookVideoAlbum();
            },
            //查看视频转接
            async lookVideoAlbum(){
                let result=await teacherDyClassroomVideoAlbum(this.selectTagId,this.currentPage,20);
                console.log(result.data);
                if(result.status){
                    this.loading=false;
                    this.totalRecords=result.data.totalRecords;
                    this.videoAlbumList=result.data.data;
                }else{
                    this.loading=false;
                }
            },
            /*选择专辑触发进入视频播放页面*/
            getInto(val){
                const {href} = this.$router.resolve(
                    {path:'/videoPlayer', query:{albumId:val}});
                this.getLocation=href;
            },
            handleClick(tab, event) {
                this.secondDefaultSelect(tab.$options.propsData.name);
            }
        }
    }
</script>
<style lang="scss">
    #teacherTraining{
        .contentBox {
            .el-tabs__item {
                font-size: 16px !important;
                font-feature-settings: 'tnum' !important;
            }
    
            .el-tabs__nav-wrap {
                height: 60px !important;
            }
    
            .el-tabs__nav {
                height: 60px !important;
            }
        }
    }
</style>

<style lang="scss">
    #teacherTraining{
        .source_item:hover{
            box-shadow: 2px 3px 8px 7px rgba(90, 139, 255, 0.12);
        }
        .contentBox {
            /*margin-left: 214px;*/
            //padding: 24px 32px;
            //min-height: calc(100vh - 60px);

            .layoutBoxWhiteBig {
                //min-height: calc(100vh - 108px);
                background-color: #fff;
                padding: 0 32px 32px 32px;

                .filterArea {
                    padding-top: 10px;
                    padding-bottom: 18px;

                    .jyTabFilter {
                        font-size: 14px;

                        .jyTabFilter-label {
                            color: #7c89a7;
                            line-height: 1;
                            float: left;
                            padding: 5px 0;
                        }

                        .jyTabFilter-li {
                            display: inline-block;
                            margin: 0 10px 12px 0;
                            border-radius: 4px;

                            > .el-button {
                                display: inline;
                                border: none;
                                //background-color: transparent;
                                cursor: pointer;
                                padding: 5px 10px;
                                outline: none;
                                line-height: 1;
                            }
                        }
                    }
                }
                .courseList{
                    .total-2OLNl {
                        color: #7C89A7;
                        padding-bottom: 15px;
                        .total-count-3psEA {
                            color: #FFB36B;
                            margin: 0 5px;
                        }
                    }
                    .course-cards-1KqlJ {
                        padding-bottom: 10px;
                        display: flex;
                        flex-wrap: wrap;
                        .course-card-32E5t {
                            width: 224px;
                            border: 1px solid #E5EAF4;
                            padding-bottom: 16px;
                            position: relative;
                            margin-right: 16px;
                            transition: all .2s;
                            .course-pic-YTvjF {
                                width: 100%;
                                height: 122px;
                                overflow: hidden;
                                img{
                                    width: 100%;
                                }
                            }
                            .course-title-3Ikmu {
                                height: 22px;
                                font-size: 14px;
                                font-weight: 400;
                                text-align: left;
                                color: #314059;
                                line-height: 22px;
                                padding: 0 16px;
                                margin: 8px 0;
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .course-desc-1wQGf {
                                font-size: 12px;
                                font-weight: 400;
                                text-align: left;
                                color: #8d96ac;
                                line-height: 20px;
                                padding: 0 16px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                height: 40px;
                            }
                        }
                        .course-item-in-list-2nSh9 {
                            margin-bottom: 16px;
                        }
                    }
                }
            }
        } 
    }

</style>
